import React, { memo, useEffect, useMemo, useState } from "react";
import { Accordion, Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
// css
import styles from "./ClientDetail.module.scss";
import { generatePath, Link, useNavigate, useParams } from "react-router-dom";

// img
import p1 from "../../../../../Assets/images/user.png";
import formIcn from "../../../../../Assets/images/formIcn.svg";
import AssignDisciplinePop from "../../../../../components/Modals/AssignDisciplinePop";
import { useArchiveClientChatterMutation, useChatterClientDetailsQuery, useFavouriteChatterClientMutation, useGetChatterClientProgramsListQuery, useLazyGetChatterClientAttendanceListQuery, useUpdateChatterClientMutation } from "store/services/clients/chatter.client";
import { EDIT_CHATTER_CLIENT, CHATTER_CLIENT_LIST, CLIENT_SERVICE_STATUS_LIST, CLIENT_ATTENDANCE_LIST, CLIENT_DOCUMENTS_LIST, CLINICIANS_HISTORY, CHATTER_CLIENT_ATTENDANCE } from "config/paths";
import { convertToMomentDate, dateFormat, formatString, getAge, successMessageToast, userFullName } from "helpers/common";
import LoadingIndicator from "components/shared/LoadingIndicator";
import { useClientsServiceStatusListQuery, useLazyGetFileUrlQuery } from "store/services/utility";
import { useGetNoteQuery } from "store/services/note";
import NotesComponent from "components/shared/FormComponents/NotesComponent";
import AddDocumentPop from "components/Modals/AddDocumentPop";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { Breadcrumbs, CommonSelect, CommonToolTip, CstmPagination, NoRecordFound } from "components/Common/Common";
import { useAssignTherapistMutation, useChangeTherapistMutation, useCreateNewCaseloadMutation, useGetClientCaseloadsListQuery, useRemoveTherapistAssignmentMutation, useRemoveTherapistMutation, useUpdateCaseloadStatusMutation, useUpdateTherapistServiceStatusMutation } from "store/services/clientCaseLoads";
import { CHATTER_CLIENT_STATUS_OPTION, CLIENT_TYPE_KEYS } from "config/constants";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import moment from "moment";
import TrackAttendance from "components/shared/TrackAttendance";
import Attachments from "components/shared/Attachments";
import GuardianDetailList from "components/shared/GuardianDetailList";
import ChangeTherapistPop from "components/Modals/ChangeTherapistPop";
import confirmDialog from "utils/confirmationDialog";
import ManageAppointmentBalance from "../../Components/ManageAppointmentBalance";
import TableHeader from "components/shared/FormComponents/TableHeader";
import ChatterSendMailPop from "components/Modals/ChatterSendMailPop";
import { Star } from "react-feather";
import { useFavouriteSchoolClientMutation } from "store/services/clients/school.client";
import { useLazyUpdateClientStatusQuery } from "store/services/client";
import confirmDialogV2 from "utils/confirmationDialogV2";
import NotesComponentV2 from "pages/SideTabPages/Notes/NotesComponentV2";
import AddPlus from "Assets/images/AddPlus";
import CliniciansAssignedComponent from "components/shared/FormComponents/V2/CliniciansAssigned/CliniciansAssignedComponent";
import SeeMore from "components/SeeMore";
import ClientAttachments from "components/shared/FormComponents/V2/ClientAttachments/ClientAttachments";
import AddClientDocumentsModal from "components/Modals/AddClientDocumentsModal";
import AssignDisciplineModal from "components/Modals/AssignDisciplinesModal";
import ReportsComponent from "components/shared/FormComponents/V2/ReportsComponent/ReportsComponent";
import DiagnosisComponent from "components/shared/FormComponents/V2/Diagnosis/DiagnosisComponent";
import ClientExpiryModal from "components/Modals/ClientExpiryModal";

const ClientChatterDetail = () => {

  const { id: clientId } = useParams();
  const navigate = useNavigate();
  const clientType = "chatter"

  const [showModal, setShowModal] = useState(false);
  const [assignDiscipline, setAssignDiscipline] = useState(false);
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [showAssignDisciplinePopup, setShowAssignDisciplinePopup] = useState(false);
  const [showRemoveModal, setShowRemoveModal] = useState(false);
  const [currentEntry, setCurrentEntry] = useState(null)
  const [showChangeModal, setShowChangeModal] = useState(null)
  const [changeTherapistId, setChangeTherapistId] = useState(null)
  const [showDischargeModal, setShowDischargeModal] = useState(false)
  const [modalType, setModalType] = useState(null)
  const [hasActiveTherapist, setHasActiveTherapist] = useState(false);
  const pageSize = 10
  const [currentPage, setCurrentPage] = useState(1)
  const [filterHistory, setFilterHistory] = useState({ search: "" })
  const [programId, setProgramId] = useState(null)
  const [isDisabled, setIsDisabled] = useState(false)
  const [clientStatus, setClientStatus] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(null)
  const [clientsDocumentModal, setClientsDocumentModal] = useState(false)
  const [assignDisciplineModal, setAssignDisciplineModal] = useState(false)
  const [clientExpiryModal, setClientExpiryModal] = useState(false)



  const { data: clientDetails, isLoading, isFetching, refetch } = useChatterClientDetailsQuery(clientId);
  const caseLoadId = clientDetails?.clientCaseloads?.find(x => x.case_type == "regular")?.id;
  const caseloadPending = clientDetails?.clientCaseloads?.find(x => x.case_type == "regular" && x.case_status == "pending") || null;
  const caseloadTherapist = clientDetails?.clientCaseloads?.find(x => x.case_type == "regular")?.clientCaseloadTherapist || [];
  const assignedTherapist = caseloadTherapist?.filter(x => x.status != 65);
  const [updateTherpaistServiceStatus, { isLoading: updateTherpaistServiceStatusLoading }] = useUpdateTherapistServiceStatusMutation()
  const [updateCaseloadStatus, { isLoading: updateCaseloadStatusLoading }] = useUpdateCaseloadStatusMutation()
  const [createNewCaseload, { isLoading: newCreateCaseloadLoading }] = useCreateNewCaseloadMutation()

  //  Service status lookup
  const { data: serviceStatusList, isLoading: serviceStatusListLoading } = useClientsServiceStatusListQuery({ module: "client_service", client_type: "chatter" });
  const serviceStatusOptions = serviceStatusList?.map(i => ({ value: i.id, label: i.title }));
  const { data: caseLoadsList, isFetching: caseLoadsListFetching } = useGetClientCaseloadsListQuery({ id: clientId, page: currentPage, limit: pageSize, ...filterHistory })
  const totalRecords = caseLoadsList?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize)
  const { data: clientPrograms, isLoading: clientProgramsLoading } = useGetChatterClientProgramsListQuery({ clientId })

  const [archiveClient, { isLoading: archiveClientLoading, }] = useArchiveClientChatterMutation();
  const [updateClient, { isLoading: updatChatterLoading }] = useUpdateChatterClientMutation();
  const [assignTherapist, { isLoading: assignTherapistLoading }] = useAssignTherapistMutation();
  const [removeTherapist, { isLoading: removeTherapistLoading }] = useRemoveTherapistMutation();
  const [changeTherapist, { isLoading: changeTherapistLoading }] = useChangeTherapistMutation();
  const [fetchAttendance, { data: attendaceList, isFetching: fetchAttendanceLoading }] = useLazyGetChatterClientAttendanceListQuery()
  const [favouriteClient, { isLoading: favouriteClientLoading }] = useFavouriteChatterClientMutation()
  const [updateStatus, { isLoading: updateStatusLoading }] = useLazyUpdateClientStatusQuery()

  const { data: noteDetails } = useGetNoteQuery({ clientId, moduleName: "clients-chatter" });

  const parents = clientDetails?.client_detail?.client_guardian_mapping?.filter((item) => item?.client_guardian?.client_role?.slug == 'parent');

  const toggleDisciplinePopup = () => setShowAssignDisciplinePopup(!showAssignDisciplinePopup);

  const uploadDocuments = async (payload) => {
    try {

      setShowDocumentModal(false);

      const values = {
        documents: payload.documents,
        firstname: clientDetails?.firstname,
        lastname: clientDetails?.lastname,
        dob: clientDetails?.client_detail?.dob,
        gender: clientDetails?.client_detail?.gender,
        city_town: clientDetails?.client_detail?.city_town,
        status: clientDetails?.status,
        funding_source: clientDetails?.client_detail?.client_chatter_detail?.funding_source,
        is_confirmed: clientDetails?.client_detail?.client_chatter_detail?.is_confirmed

      };

      const result = await updateClient({ clientId, data: values, });

      if (result?.error) {
        console.error("Error adding document in chatter Client", result.error);
      } else {
        successMessageToast(result?.data?.message);
      }
    } catch (err) {
      console.error("Error adding document in chatter Client", err);
    }
  };

  const handleAssignTherapist = async (values) => {
    try {
      let payload = {
        caseload_id: values?.caseload_id,
        discipline_id: values?.discipline_id?.value,
        therapist_id: values?.therapist_id?.value,
      }
      let { data, error } = await assignTherapist(payload);
      if (error) {
        return;
      }

      successMessageToast(data?.message);
      setShowAssignDisciplinePopup(false);
      refetch();
    } catch (err) {
      console.error("Error assigning therapist", err);
    }
  };

  const handleRemoveTherapist = async () => {
    try {

      setShowRemoveModal(false);
      let { data, error } = await removeTherapist(currentEntry?.id);
      if (error) {
        return;
      }

      successMessageToast(data?.message);
      refetch();
    } catch (err) {
      console.error("Error removing Therapist assignment", err);
    }
  };

  const handleArchive = async () => {
    try {

      setShowModal(false);

      const result = await archiveClient(clientId);
      if (!result?.error) successMessageToast("Record has been updated successfully.");

    } catch (err) {
      console.error("error archiving client chatter", err);
    };
  };

  const handleChangeTherapist = async (values) => {
    try {
      let { data, error } = await changeTherapist({ assignmentId: currentEntry?.id, therapistId: values?.therapist_id?.value });
      if (error) {
        return;
      }
      refetch();
      setShowChangeModal(false);
      successMessageToast(data?.message);
    } catch (err) {
      console.error("Error change Therapist", err);
    }
  }

  const handleServiceStatus = async (id, therapistId) => {
    const payload = {
      service_status: id
    }
    try {
      await updateTherpaistServiceStatus({ payload, id: therapistId }).unwrap()
      refetch()
    } catch (error) {
      console.log("Error updating service status: ", error)
    }
  }

  const handleUpdateClient = (field) => async (value) => {
    try {
      let confirm = await confirmDialog({ type: "update" });
      if (!confirm) {
        return;
      }

      const data = {
        [field]: value
      }
      await updateClient({ clientId, data }).unwrap();
    } catch (err) {
      console.error("Error updating client", err);
    }
  }

  const handleCaseloadDischarge = async () => {
    setShowDischargeModal(false)
    const payload = {
      case_status: "complete"
    }
    try {
      const result = await updateCaseloadStatus({ payload, id: caseLoadId }).unwrap()
      successMessageToast(result?.message)
      refetch()
    } catch (error) {
      console.log("error discharging: ", error)
    }
  }

  const handleCreateCaseLoad = async () => {
    setShowDischargeModal(false)
    try {
      const result = await createNewCaseload({ id: clientId }).unwrap()
      refetch()
      successMessageToast(result?.message)
      setModalType(null)
      toggleDisciplinePopup()
    } catch (error) {
      console.log("error creating new caseload: ", error)
    }
  }

  const resetFilter = () => {
    setFilterHistory({ search: "" })
    setCurrentPage(1)
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const handleFilterChange = (key) => (value) => {
    setFilterHistory({ ...filterHistory, [key]: value })
    setCurrentPage(1); // Reset to first page when filter changes
  };


  const handleProgram = async (programId) => {
    setProgramId(programId)
    const program = clientPrograms?.programs?.find((item) => item?.program_id == programId?.value)
    console.log('handle program', program)
    try {
      await fetchAttendance({ programId: programId?.value, clientId: program?.id }).unwrap()
    } catch (error) {
      console.log('error fetching attendance: ', error)
    }
  }

  const handleFavouriteClient = async (id, favorite) => {
    const data = {
      favorite
    }
    try {
      const response = await favouriteClient({ data, id }).unwrap()
      refetch();
      successMessageToast(response?.message)
    } catch (error) {
      console.log('error making the client favourite: ', error)
    }
  }

  const handleUpdateStatus = async (e, status) => {
    // e.stopPropagation();
    const isConfirm = await confirmDialogV2({
      title: "STATUS CHANGE ?",
      message: "Are you sure you want to change the client status ?",
    });
    if (!isConfirm) {
      return;
    }
    try {
      await updateStatus({ clientId, clientType, status: status?.value }).unwrap();
      refetch()
      // navigate(generatePath(SCHOOL_CLIENT_DETAIL, { id: clientId }))
    } catch (error) {
      console.log('error', error)
    }
  }

  // useEffect(() => {
  //   const result = assignedTherapist?.some(
  //     (assignment) => assignment?.caseServiceStatus?.title?.toLowerCase() !== 'discharge'
  //   );
  //   setHasActiveTherapist(result || false); // fallback to false if result is undefined
  // }, [assignedTherapist]);

  useEffect(() => {
    if (clientDetails?.status) {
      setClientStatus({ label: formatString(clientDetails?.status), value: clientDetails?.status })
    }
  }, [clientDetails])

  const breadcrumbItems = [
    { label: "Chatter Client", path: CHATTER_CLIENT_LIST },
    { label: userFullName(clientDetails) || "Client Details" },
  ];

  const therapist = {}


  return (
    <>
      <ChangeTherapistPop
        showPopup={showChangeModal}
        setShowPopup={setShowChangeModal}
        discipline={currentEntry?.discipline_id}
        currentTherapist={currentEntry?.id}
        handleSubmit={handleChangeTherapist}
        isLoading={changeTherapistLoading}
        therapistId={currentEntry?.therapist_id}
      />
      <ConfirmationPop
        confirmation={showRemoveModal}
        setConfirmation={setShowRemoveModal}
        confirmHandler={handleRemoveTherapist}
        type="remove"
      />

      <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        confirmHandler={handleArchive}
        type={clientDetails?.status == "active" ? "archive" : "active"}
      />

      <ConfirmationPop
        confirmation={showDischargeModal}
        setConfirmation={setShowDischargeModal}
        confirmHandler={modalType ? handleCreateCaseLoad : handleCaseloadDischarge}
        type={modalType ? modalType : "caseloadDischarge"}
      />

      <AssignDisciplinePop
        showPopup={showAssignDisciplinePopup}
        setShowPopup={setShowAssignDisciplinePopup}
        caseLoadId={caseLoadId}
        handleSubmit={handleAssignTherapist}
        isLoading={assignTherapistLoading}
      />

      <AddDocumentPop
        show={showDocumentModal}
        setShow={setShowDocumentModal}
        handleSubmit={uploadDocuments}
      />

      <AssignDisciplinePop
        assignDiscipline={assignDiscipline}
        setAssignDiscipline={setAssignDiscipline}
      />
      {/* V2 MODALS */}
      <AddClientDocumentsModal
        show={clientsDocumentModal}
        setShow={setClientsDocumentModal}
        clientId={clientId}
        refetch={refetch}
      />
      <AssignDisciplineModal
        show={assignDisciplineModal}
        setShow={setAssignDisciplineModal}
        caseLoadId={caseloadPending?.id}
        clientDetails={clientDetails}
        refetch={refetch}
      />
      <ClientExpiryModal
        show={clientExpiryModal}
        setShow={setClientExpiryModal}
        refetch={refetch}
        clientDetails={clientDetails}
        clientType={clientType}
        clientId={clientId}
        caseLoadId={clientDetails?.clientCaseloads?.find(x => x.case_type == "regular")?.clientCaseloadTherapist?.[0]?.id}
      />
      <section
        className={`${styles.ClientDetail} position-relative ClientDetail`}
      >
        <Container fluid={true}>
          {
            isLoading ? <LoadingIndicator /> :
              <Row>
                {(updatChatterLoading || favouriteClientLoading || removeTherapistLoading || isFetching || caseLoadsListFetching || updateCaseloadStatusLoading || newCreateCaseloadLoading || updateTherpaistServiceStatusLoading || archiveClientLoading || fetchAttendanceLoading || updateStatusLoading) && <LoadingOverlay />}
                <Row className="pt-3">
                  <Col lg="7">
                    <Breadcrumbs themeBlueV2 items={breadcrumbItems} />
                  </Col>
                  <Col lg="5">

                  </Col>
                </Row>

                <div style={{ marginTop: clientDetails?.status == 'active' ? "-10px" : '20px' }}>
                  <p>
                    <div className="d-flex align-items-end gap-2 proxima-regular">
                      <div className="cursor-pointer" onClick={() => { !favouriteClientLoading && handleFavouriteClient(clientDetails?.client_detail?.id, clientDetails?.client_detail?.is_favorite ? 0 : 1) }}>{clientDetails?.client_detail?.is_favorite ? <Star fill="#315D99" stroke="#315D99" /> : <Star />}
                      </div>
                      <Row className="w-100 align-items-end">
                        <Col lg='7'>
                          <div className="d-flex gap-3 align-items-end">
                            <p className="twenty proxima-regular mb-0 d-flex gap-2" style={{ color: "#000", fontSize: "20px" }}>
                              {clientDetails?.status != 'active' && <div className="text-capitalize">{`${clientDetails?.status}:`}</div>}{" "}{userFullName(clientDetails)} <span onClick={() => navigate(generatePath(CLIENT_SERVICE_STATUS_LIST, { clientId, clientType }))} className="themeBlueV2 cursor-pointer ten ms-2" style={{ textDecoration: "underline" }}>SERVICE STATUS</span>
                            </p>
                            <div style={{ width: "25%" }} className="reports-v2 classroom-conslutation">
                              <div className="w-100 align-items-center gap-3">
                                {/* <label className="discharge-screen-label mb-0">School</label> */}
                                <CommonSelect
                                  placeholder={"Choose one..."}
                                  option={CHATTER_CLIENT_STATUS_OPTION?.filter((item) => item?.value)}
                                  onChange={(e) => handleUpdateStatus(e, e)}
                                  value={clientStatus}
                                  // onInputChange={(val) => handleSearch(val)}
                                  isFilterV2
                                  // isClearable
                                  styles={{
                                    container: (provided) => ({
                                      ...provided,
                                      width: "100%",
                                    }),
                                  }}
                                // isLoading={schoolsLoading}
                                />
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col lg='5'>
                          <div className="d-flex align-items-end justify-content-end gap-3">
                            {/* <div onClick={() => navigate(generatePath(CLIENT_ATTENDANCE_LIST, { clientId, clientType }))} className="text-end">
                              <span className="themeBlueV2 cursor-pointer ten ms-2 fw-medium fs-8" style={{ textDecoration: "underline", marginTop: clientDetails?.status != 'active' && "10px" }}>SEE ATTENDANCE DETAILS</span>
                            </div> */}
                            <div style={{ display: "flex", gap: "10px" }}>
                              <div style={{ marginLeft: "auto", width: "150px", borderRadius: "4px", border: "1px solid #8F8F8F", padding: "10px 12px" }}>
                                <Row className="mb-1">
                                  <Col lg='12'>
                                    <h3 className="black ten proxima-regular" style={{ fontWeight: "600", fontSize: '14px' }}>FUNDING SOURCE</h3>
                                  </Col>
                                  <Col lg='6'>
                                    <h2 className="black mb-0 forteen  text-start">{clientDetails?.client_detail?.client_chatter_detail?.chatter_funding_source?.name || "--"}</h2>
                                  </Col>
                                </Row>
                              </div>
                              {
                                <div className="cursor-pointer" onClick={() => setClientExpiryModal(true)} style={{ marginLeft: "auto", width: "220px", borderRadius: "4px", border: "1px solid #8F8F8F", padding: "10px 12px" }}>
                                  <Row className="mb-1">
                                    <Col lg='6'>
                                      <h3 className="black ten proxima-regular" style={{ fontWeight: "600" }}>ACCOUNT STATUS</h3>
                                    </Col>
                                    <Col lg='6'>
                                      <h3 className="black ten proxima-regular text-start" style={{ fontWeight: "600" }}>DATE OF EXPIRY</h3>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col lg='6'>
                                      <h2 className="forteen mb-0 proxima-regular text-capitalize" style={{ color: clientDetails?.status == 'active' && "#55A215", fontStyle: ["archived", "discharged"]?.includes(clientDetails?.status) && "italic" }}>{clientDetails?.status}</h2>
                                    </Col>
                                    <Col lg='6'>
                                      <h2 className="black mb-0 text-start" style={{fontSize: "13px"}}>{clientDetails?.client_detail?.date_of_expiry ? dateFormat(clientDetails?.client_detail?.date_of_expiry, "MMM DD, YYYY") : "--"}</h2>
                                    </Col>
                                  </Row>
                                </div>
                              }
                              {/* <div style={{ width: "148px" }} onClick={() => { if (!isDischarged && !isInactive) setAttendanceModal(true) }}>
                                              <h2 style={{
                                                border: "1px solid #93278F",
                                                padding: "10px 12px",
                                                cursor: (!isDischarged && !isInactive) ? "pointer" : "not-allowed",
                                                opacity: (!isDischarged && !isInactive) ? 1 : 0.5,
                                                pointerEvents: (!isDischarged && !isInactive) ? "auto" : "none"
                                              }} className="themePurple mb-0 cursor-pointer proxima-regular forteen text-center">Track Attendance</h2>
                                            </div> */}
                              <div style={{ width: "148px" }} onClick={() => navigate(generatePath(CHATTER_CLIENT_ATTENDANCE, { id: clientId }))}
                              >
                                <h2 style={{
                                  border: "1px solid #93278F",
                                  padding: "10px 12px",
                                  cursor: (!isDisabled) ? "pointer" : "not-allowed",
                                  opacity: (!isDisabled) ? 1 : 0.5,
                                  pointerEvents: (!isDisabled) ? "auto" : "none"
                                }} className="themePurple mb-0 cursor-pointer proxima-regular forteen text-center">Attendance History</h2>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </p>
                </div>

                <div className="session-header-date" style={{ backgroundColor: "#F5F5F5", padding: "11px 21px" }}>
                  <div className="d-flex align-items-center gap_20">
                    <div className="mt-1" style={{ width: "100%" }}>
                      <div className="d-flex justify-content-between">
                        <div style={{ display: "inline-flex" }} className="date-title justify-content-between">
                          <h6 className="mb-0" style={{ marginTop: "3px", fontSize: "14px" }}>CLIENT INFORMATION</h6>
                          <div className="d-flex align-items-center gap-2">
                            {/* <label style={{ fontSize: '10px', color: "purple", textDecoration: "underline" }} className="discharge-screen-label mb-0 ">SEE MORE </label> */}
                            <p className="mb-0 proxima_light" style={{ fontSize: "14px" }}>{userFullName(clientDetails?.record?.reportsPreflightTeacher)}</p>
                          </div>
                        </div>
                        {/* <SeeMore title='SEE MORE' /> */}
                      </div>
                      <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-5">
                          <div>
                            <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>DATE OF BIRTH</h5>
                            <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{clientDetails?.client_detail?.dob ? moment(clientDetails?.client_detail?.dob).format("DD/MM/YYYY") : "--"}</p>
                          </div>
                          <div>
                            <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>GENDER</h5>
                            <p className="mb-0 proxima_light text-capitalize" style={{ fontSize: "14px", color: "#000" }}>{clientDetails?.client_detail?.gender || "--"}</p>
                          </div>
                          <div>
                            <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>CITY/TOWN</h5>
                            <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{clientDetails?.client_detail?.city_town || "--"}</p>
                          </div>
                        </div>

                        <div className="d-flex align-items-center gap-4">
                          <div>
                            <h5 className="discharge-screen-label text-end" style={{ fontSize: "10px", color: "#000" }}>GRADE</h5>
                            <p className="mb-0 text-end proxima_light" style={{ fontSize: "14px", color: "#000" }}>{clientDetails?.client_detail?.grade || "--"}</p>
                          </div>
                          <div>
                            <h5 className="discharge-screen-label text-end" style={{ fontSize: "10px", color: "#000" }}>AGE</h5>
                            <p className="mb-0 text-end proxima_light" style={{ fontSize: "14px", color: "#000" }}>{clientDetails?.client_detail?.dob ? getAge(clientDetails?.client_detail?.dob) : "--"}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex align-items-center gap_20">
                    <div className="mt-1" style={{ width: "100%" }}>
                       {
                        parents?.map((item, index) => index <= 1  && <>
                          <div className="date-title d-flex justify-content-between pt-3">
                            <h6 className="mb-0" style={{ marginTop: "3px", fontSize: "14px", color: "#000", textTransform: "capitalize" }}>{`${item?.client_guardian?.client_role?.slug.toUpperCase()} ${index + 1}`}</h6>
                          </div>
                          <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between">
                            <div className="d-flex align-items-center gap-5">
                              <div>
                                <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>LAST NAME</h5>
                                <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{item?.client_guardian?.lastname || "--"}</p>
                              </div>
                              <div>
                                <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>FIRST NAME</h5>
                                <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{item?.client_guardian?.firstname || "--"}</p>
                              </div>
                              <div>
                                <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>EMAIL</h5>
                                <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{item?.client_guardian?.email || "--"}</p>
                              </div>
                            </div>
                          </div>
                        </>)
                      }
                      {
                        clientDetails?.client_detail?.client_guardian_mapping?.map((item, index) => item?.client_guardian?.client_role?.slug != 'parent' && <>
                          <div className="date-title d-flex justify-content-between pt-3">
                            <h6 className="mb-0" style={{ marginTop: "3px", fontSize: "14px", color: "#000", textTransform: "capitalize" }}>{`${item?.client_guardian?.client_role?.slug.toUpperCase()}`}</h6>
                          </div>
                          <div className="d-flex flex-wrap gap-3 align-items-center justify-content-between">
                            <div className="d-flex align-items-center gap-5">
                              <div>
                                <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>LAST NAME</h5>
                                <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{item?.client_guardian?.lastname || "--"}</p>
                              </div>
                              <div>
                                <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>FIRST NAME</h5>
                                <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{item?.client_guardian?.firstname || "--"}</p>
                              </div>
                              <div>
                                <h5 className="discharge-screen-label" style={{ fontSize: "10px", color: "#000" }}>EMAIL</h5>
                                <p className="mb-0 proxima_light" style={{ fontSize: "14px", color: "#000" }}>{item?.client_guardian?.email || "--"}</p>
                              </div>
                            </div>
                          </div>
                        </>)
                      }
                    </div>
                  </div>

                </div>

                <section>
                  <Row className="pt-4">
                    <Col lg="6">
                      <div style={{ border: "1px solid #C7C7C7", padding: "12px", borderRadius: "4px" }}>
                        {/* <NotesComponent
                                        client_id={clientId}
                                        module={"clients-school"}
                                        disabled={isDischarged}
                                      /> */}
                        <NotesComponentV2
                          client_id={clientId}
                          module={"clients-chatter"}
                          v2={true}
                        />
                      </div>
                    </Col>
                    <Col lg="6">
                      <div style={{ border: "1px solid #C7C7C7", padding: "12px", borderRadius: "4px" }}>
                        <Row>
                          <Col lg='8'>
                            <div className="d-flex gap-2">
                              <h6 className="mb-0 forteen proxima-regular" style={{ marginTop: "3px" }}>CLINICIANS
                                {/* <span onClick={() => navigate(generatePath(CLINICIANS_HISTORY, { clientId, clientType }))} className="themeBlue cursor-pointer ten ms-2" style={{ textDecoration: "underline" }}>HISTORY</span> */}
                              </h6>
                              <SeeMore onClick={() => navigate(generatePath(CLINICIANS_HISTORY, { clientId, clientType }))} title='HISTORY' />
                            </div>
                          </Col>
                          <Col lg='4' className="text-end">
                            <AddPlus isDisabled={isDisabled} onClick={() => !isDisabled && setAssignDisciplineModal(true)} />
                          </Col>
                        </Row>
                        <CliniciansAssignedComponent refetch={refetch} isDisabled={isDisabled} onClick={() => clientDetails?.status != "discharged" && setAssignDisciplineModal(true)} clientDetails={clientDetails} setCurrentEntry={setCurrentEntry} setShowDeleteModal={setShowDeleteModal} />
                      </div>
                      <div className="mt-4" style={{ border: "1px solid #C7C7C7", padding: "12px", borderRadius: "4px" }}>
                        <Row>
                          <Col lg='8'>
                            <div className="d-flex gap-2">
                              <h6 onClick={() => navigate(generatePath(CLIENT_DOCUMENTS_LIST, { clientId, clientType }))} className="mb-0 forteen proxima-regular" style={{ marginTop: "3px" }}>DOCUMENTS
                                {/* <span className="themeBlue cursor-pointer ten ms-2" style={{ textDecoration: "underline" }}>SHOW ALL</span> */}
                              </h6>
                              <SeeMore onClick={() => navigate(generatePath(CLIENT_DOCUMENTS_LIST, { clientId, clientType }))} title='SHOW ALL' />
                            </div>
                          </Col>
                          <Col lg='4' className="text-end">
                            {/* <svg style={{ opacity: clientDetails?.status == "discharged" && "0.5" }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" fill="none" className="mx-1"><mask id="mask0_0_12941" maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32" style={{ maskType: "alpha" }}><rect width="32" height="32" fill="#D9D9D9"></rect></mask><g mask="url(#mask0_0_12941)"><path d="M14.6667 17.3337V21.3337C14.6667 21.7114 14.7945 22.0281 15.0501 22.2837C15.3056 22.5392 15.6223 22.667 16.0001 22.667C16.3779 22.667 16.6945 22.5392 16.9501 22.2837C17.2056 22.0281 17.3334 21.7114 17.3334 21.3337V17.3337H21.3334C21.7112 17.3337 22.0279 17.2059 22.2834 16.9503C22.539 16.6948 22.6667 16.3781 22.6667 16.0003C22.6667 15.6225 22.539 15.3059 22.2834 15.0503C22.0279 14.7948 21.7112 14.667 21.3334 14.667H17.3334V10.667C17.3334 10.2892 17.2056 9.97255 16.9501 9.71699C16.6945 9.46144 16.3779 9.33366 16.0001 9.33366C15.6223 9.33366 15.3056 9.46144 15.0501 9.71699C14.7945 9.97255 14.6667 10.2892 14.6667 10.667V14.667H10.6667C10.289 14.667 9.9723 14.7948 9.71675 15.0503C9.46119 15.3059 9.33342 15.6225 9.33342 16.0003C9.33342 16.3781 9.46119 16.6948 9.71675 16.9503C9.9723 17.2059 10.289 17.3337 10.6667 17.3337H14.6667ZM16.0001 29.3337C14.1556 29.3337 12.4223 28.9837 10.8001 28.2837C9.17786 27.5837 7.76675 26.6337 6.56675 25.4337C5.36675 24.2337 4.41675 22.8225 3.71675 21.2003C3.01675 19.5781 2.66675 17.8448 2.66675 16.0003C2.66675 14.1559 3.01675 12.4225 3.71675 10.8003C4.41675 9.1781 5.36675 7.76699 6.56675 6.56699C7.76675 5.36699 9.17786 4.41699 10.8001 3.71699C12.4223 3.01699 14.1556 2.66699 16.0001 2.66699C17.8445 2.66699 19.5779 3.01699 21.2001 3.71699C22.8223 4.41699 24.2334 5.36699 25.4334 6.56699C26.6334 7.76699 27.5834 9.1781 28.2834 10.8003C28.9834 12.4225 29.3334 14.1559 29.3334 16.0003C29.3334 17.8448 28.9834 19.5781 28.2834 21.2003C27.5834 22.8225 26.6334 24.2337 25.4334 25.4337C24.2334 26.6337 22.8223 27.5837 21.2001 28.2837C19.5779 28.9837 17.8445 29.3337 16.0001 29.3337Z" fill="#315D99"></path></g></svg> */}
                            <AddPlus isDisabled={isDisabled} onClick={() => clientDetails?.status != "discharged" && setClientsDocumentModal(true)} />
                          </Col>
                        </Row>
                        <ClientAttachments
                          isPage={false}
                          resources={clientDetails?.clientResources || []}
                          clientId={clientId}
                          refetch={refetch}
                          clientType={CLIENT_TYPE_KEYS.school}
                          limit={4}
                          onClick={() => clientDetails?.status != "discharged" && setClientsDocumentModal(true)}
                          isDisabled={isDisabled}
                        />
                      </div>
                    </Col>
                  </Row>
                </section>

                <section>
                  <div className="mt-4" style={{ border: "1px solid #C7C7C7", padding: "12px", borderRadius: "4px" }}>
                    <ReportsComponent clientId={clientId} clientType={clientType} isPage={false} />
                  </div>
                </section>

                {/* <section className="mt-4 pb-3">
                  <DiagnosisComponent client_id={clientId} clientType={clientType} />
                </section> */}

                {/* <Col
                  lg="6"
                  className=""
                  style={{ borderRight: "1px solid #3da0aa4f" }}
                >
                  <Row>
                    <Col lg="12" className="my-3">
                      <div className="pageHead d-flex align-items-center justify-content-between flex-wrap gap-10">
                        <div className="left">
                          <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center">
                            <li className="">
                              <Link
                                className="themeBlue fw-sbold back-to-btn"
                                to={CHATTER_CLIENT_LIST}
                              >
                                <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M6 12L0 6L6 0L7.425 1.4L2.825 6L7.425 10.6L6 12ZM18 14V10C18 9.16667 17.7083 8.45833 17.125 7.875C16.5417 7.29167 15.8333 7 15 7H8.825L12.425 10.6L11 12L5 6L11 0L12.425 1.4L8.825 5H15C16.3833 5 17.5625 5.4875 18.5375 6.4625C19.5125 7.4375 20 8.61667 20 10V14H18Z" fill="#1C1B1F" />
                                </svg> Back
                              </Link>
                            </li>
                            <li className="">
                              <Link
                                className="themeBlue fw-sbold"
                                style={{ textDecoration: "underline" }}
                                to={CHATTER_CLIENT_LIST}
                              >
                                Chatter
                              </Link>
                            </li>
                            <li className="">
                              <h5 className="m-0 fw-bold themeBlue">
                                / Client Details
                              </h5>
                            </li>
                          </ul>
                        </div>
                        <div className="right">
                          <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10">
                            <li className="">
                              <Button
                                className="d-flex align-items-center rounded-pill justify-content-center btn-sm"
                                variant="outline-success"
                                onClick={() => navigate(EDIT_CHATTER_CLIENT.replace(":id", clientId))}
                              >
                                <span className="icn me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    viewBox="0 0 18 18"
                                    fill="none"
                                  >
                                    <mask
                                      id="mask0_0_2439"
                                      style={{ maskType: "alpha" }}
                                      maskUnits="userSpaceOnUse"
                                      x="0"
                                      y="0"
                                      width="18"
                                      height="18"
                                    >
                                      <rect width="18" height="18" fill="#D9D9D9" />
                                    </mask>
                                    <g mask="url(#mask0_0_2439)">
                                      <path
                                        d="M1.5 17.9997V15.7497H16.5V17.9997H1.5ZM4.5 12.3099H5.42737L11.6524 6.0963L11.1808 5.61761L10.7136 5.15749L4.5 11.3825V12.3099ZM3.375 13.4349V10.9036L11.7823 2.50792C11.8909 2.3993 12.0142 2.31711 12.1523 2.26136C12.2901 2.20561 12.4336 2.17773 12.5828 2.17773C12.732 2.17773 12.8765 2.20561 13.0163 2.26136C13.156 2.31711 13.2841 2.40317 13.4004 2.51955L14.3019 3.43249C14.4183 3.54111 14.5024 3.66555 14.5543 3.8058C14.6062 3.94592 14.6321 4.0908 14.6321 4.24042C14.6321 4.38067 14.6058 4.52011 14.5532 4.65873C14.5006 4.79748 14.4168 4.9243 14.3019 5.03917L5.90625 13.4349H3.375ZM11.6524 6.0963L11.1808 5.61761L10.7136 5.15749L11.6524 6.0963Z"
                                        fill="currentColor"
                                      />
                                    </g>
                                  </svg>
                                </span>
                                Edit
                              </Button>
                            </li>
                            <li className="">
                              <Button
                                className="d-flex align-items-center rounded-pill justify-content-center btn-sm"
                                variant="outline-danger"
                                onClick={() => setShowModal(true)}
                                disabled={archiveClientLoading || isFetching}
                              >
                                {clientDetails?.status == "active" ? <span className="icn me-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="12"
                                    height="14"
                                    viewBox="0 0 12 14"
                                    fill="none"
                                  >
                                    <path
                                      d="M2.48081 13.3753C2.10681 13.3753 1.78731 13.2429 1.52231 12.978C1.25744 12.713 1.125 12.3935 1.125 12.0195V2.50029H0.375V1.37529H3.75V0.711914H8.25V1.37529H11.625V2.50029H10.875V12.0195C10.875 12.3984 10.7438 12.719 10.4813 12.9815C10.2188 13.244 9.89806 13.3753 9.51919 13.3753H2.48081ZM9.75 2.50029H2.25V12.0195C2.25 12.0869 2.27162 12.1422 2.31487 12.1854C2.35812 12.2287 2.41344 12.2503 2.48081 12.2503H9.51919C9.57694 12.2503 9.62981 12.2262 9.67781 12.1781C9.72594 12.1301 9.75 12.0772 9.75 12.0195V2.50029ZM4.053 10.7503H5.17781V4.00029H4.053V10.7503ZM6.82219 10.7503H7.947V4.00029H6.82219V10.7503Z"
                                      fill="currentColor"
                                    />
                                  </svg>
                                </span> : null}
                                {clientDetails?.status == "active" ? "Archive" : "Active"}
                              </Button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </Col>
                    <Col lg="12" className="my-3">
                      <div className="d-flex align-items-center justify-content-between gap-10 flex-wrap pb-3">
                        <div className="top d-flex align-items-center gap-10">
                          <div
                            className="igmWrp flex-shrink-0 d-flex themeBlue fw-sbold align-items-center justify-content-center rounded-circle"
                            style={{ height: 35, width: 35, background: "#DBDBDB" }}
                          >
                            {clientDetails?.firstname[0]?.toUpperCase() + clientDetails?.lastname[0]?.toUpperCase()}
                          </div>
                          <div className="content">
                            <h6 className="m-0 themeBlue fw-sbold">{userFullName(clientDetails)}</h6>
                          </div>
                        </div>
                      </div>
                      <Row>
                        <Col lg="6" md="4" sm="6" className="my-2">
                          <div className="cardCstm p-2 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              DOB
                            </h6>
                            <p style={{ fontSize: "14px" }} className="m-0 themeBlue pt-2">{clientDetails?.client_detail?.dob || "--"}</p>
                          </div>
                        </Col>
                        <Col lg="6" md="4" sm="6" className="my-2">
                          <div className="cardCstm p-2 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Gender
                            </h6>
                            <p style={{ fontSize: "14px" }} className="m-0 themeBlue pt-2 text-capitalize">{clientDetails?.client_detail?.gender || "--"}</p>
                          </div>
                        </Col>
                        <Col lg="4" md="4" sm="6" className="my-2">
                          <div className="cardCstm p-2 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              City/Town
                            </h6>
                            <p style={{ fontSize: "14px" }} className="m-0 themeBlue pt-2">{clientDetails?.client_detail?.city_town || "--"}</p>
                          </div>
                        </Col>
                        <Col sm="4" className="my-2">
                          <div className="cardCstm p-2 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Funding Source
                            </h6>
                            <div className="content d-flex align-items-center">
                              <p style={{ fontSize: "14px" }} className="m-0 text-muted mx-1">{clientDetails?.client_detail?.client_chatter_detail?.chatter_funding_source?.name || "--"}</p>
                            </div>
                          </div>
                        </Col>
                        <Col sm="4" className="my-2">
                          <div className="cardCstm p-2 bg-white shadow h-100 rounded">
                            <h6 className="m-0 themeBlue fw-bold">
                              {" "}
                              <span className="" style={{ color: "#3DA0AA" }}>
                                ■
                              </span>{" "}
                              Grade
                            </h6>
                            <div className="content d-flex align-items-center">
                              <p style={{ fontSize: "14px" }} className="m-0 text-muted mx-1">{clientDetails?.client_detail?.grade || "--"}</p>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col lg="12" className="my-3">
                      <NotesComponent
                        notes={noteDetails}
                        className={`${styles.formControl} form-control`}
                        module={"clients-chatter"}
                        client_id={clientId}
                      />
                    </Col>
                    <Col lg="12" className="my-3">
                      <GuardianDetailList
                        type="Parent"
                        guardianList={clientDetails?.client_detail?.client_guardian_mapping || []}
                      />
                    </Col>


                    <Col lg="12" className="my-3">

                      <Row>

                        <Col lg="12" className="my-3">
                          {
                            caseloadPending?.case_status == "pending" &&
                            <div className="top pb-3 d-flex justify-content-between align-items-center">
                              <h6 className="m-0 fw-bold pb-2">Assigned Therapist</h6>
                              <div className="d-flex gap-2">
                                <Button
                                  disabled={!(assignedTherapist?.length > 0) || updateCaseloadStatusLoading || isFetching || hasActiveTherapist}
                                  onClick={() => setShowDischargeModal(true)}
                                  style={{ padding: "0px 8px", height: "35px" }}
                                  className="d-flex align-items-center justify-content-center commonBtn"
                                >
                                  Discharge
                                </Button>
                                <Button
                                  disabled={updateCaseloadStatusLoading}
                                  onClick={toggleDisciplinePopup}
                                  style={{ padding: "0px 8px", height: "35px" }}
                                  className="d-flex align-items-center justify-content-center commonBtn"
                                >
                                  Assign New Discipline
                                </Button>
                              </div>
                            </div>
                          }
                          {
                            caseloadPending && ((assignedTherapist?.length > 0) ? (
                              <Row>
                                {assignedTherapist?.map(assignment => {
                                  if (assignment?.status != 65) return (
                                    <Col md="6" className="my-2">
                                      <div className="w-100 d-flex justify-content-between align-items-center mb-2">
                                        <h6 class="m-0 themeBlue fw-bold">
                                          {" "}
                                          <span class="" style={{ color: " rgb(61, 160, 170)" }}>
                                            ■
                                          </span>{" "}
                                          Discipline: {assignment?.caseDiscipline?.assign_term}

                                        </h6>
                                        <CommonToolTip
                                          text={"Remove Therapist"}
                                          component={
                                            <DeleteIcon
                                              className="cursor-pointer"
                                              onClick={() => {
                                                setCurrentEntry(assignment);
                                                setShowRemoveModal(true)
                                              }}
                                            />
                                          }
                                        />
                                      </div>
                                      <div
                                        className="cardCstm rounded shadow"
                                        style={{ border: "1px solid rgb(61, 160, 170)" }}
                                      >
                                        <div className="top px-2">
                                          <div className="d-flex align-items-center justify-content-between">
                                            <div className="left">
                                              <h6
                                                class="m-0 themeBlue fw-bold pb-2"
                                                style={{ fontSize: 14 }}
                                              >
                                                {" "}
                                                <span
                                                  class=""
                                                  style={{ color: " rgb(61, 160, 170)" }}
                                                >
                                                  ■
                                                </span>{" "}
                                                Service Status
                                              </h6>
                                              <div className="content">
                                                <Dropdown onSelect={(e) => handleServiceStatus(e, assignment?.id)}>
                                                  <Dropdown.Toggle
                                                    className="border-0 text-dark px-3 py-1 d-flex align-items-center justify-content-between fw-sbold"
                                                    style={{
                                                      background: "#F3F3F3",
                                                      height: "32px",
                                                      fontSize: "13px",
                                                      borderRadius: "20px",
                                                      minWidth: "130px",
                                                      boxShadow: "inset 0 0 2px #ccc",
                                                    }}
                                                    id="dropdown-basic"
                                                  >
                                                    <span style={{ whiteSpace: "nowrap" }}>{assignment?.caseServiceStatus?.title}</span>
                                                    <span className="ms-2">
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="10"
                                                        height="5"
                                                        viewBox="0 0 10 5"
                                                        fill="none"
                                                      >
                                                        <path
                                                          d="M4.99997 4.27048L0.816406 0.0869141H9.18353L4.99997 4.27048Z"
                                                          fill="#1C1B1F"
                                                        />
                                                      </svg>
                                                    </span>
                                                  </Dropdown.Toggle>

                                                  <Dropdown.Menu className="w-100 small p-0" style={{ fontSize: "13px" }}>
                                                    {
                                                      serviceStatusOptions?.map((item, index) => (
                                                        <Dropdown.Item key={index} eventKey={item.value}>
                                                          {item.label}
                                                        </Dropdown.Item>
                                                      ))
                                                    }
                                                  </Dropdown.Menu>
                                                </Dropdown>
                                              </div>
                                            </div>
                                            <div className="right my-2">
                                              <h6
                                                class="m-0 themeBlue fw-bold pb-2"
                                                style={{ fontSize: 14 }}
                                              >
                                                {" "}
                                                <span
                                                  class=""
                                                  style={{ color: " rgb(61, 160, 170)" }}
                                                >
                                                  ■
                                                </span>{" "}
                                                Referred
                                              </h6>
                                              <div className="content">
                                                <p
                                                  className="m-0 "
                                                  style={{
                                                    maxWidth: "max-content",
                                                    fontSize: 12,
                                                  }}
                                                >
                                                  {convertToMomentDate(assignment?.createdAt)}
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="d-flex align-items-center justify-content-between">
                                            <div className="left">
                                              <h6
                                                class="m-0 themeBlue fw-bold pb-2"
                                                style={{ fontSize: 14 }}
                                              >
                                                {" "}
                                                <span
                                                  class=""
                                                  style={{ color: " rgb(61, 160, 170)" }}
                                                >
                                                  ■
                                                </span>{" "}
                                                Assessment Date
                                              </h6>
                                              <div className="content">
                                                <p
                                                  className="m-0"
                                                  style={{
                                                    maxWidth: "max-content",
                                                    fontSize: 12,
                                                  }}
                                                >
                                                </p>
                                              </div>
                                            </div>
                                            <div className="right my-2">
                                              <h6
                                                class="m-0 themeBlue fw-bold pb-2"
                                                style={{ fontSize: 14 }}
                                              >
                                                {" "}
                                                <span
                                                  class=""
                                                  style={{ color: " rgb(61, 160, 170)" }}
                                                >
                                                  ■
                                                </span>{" "}
                                                Start Date
                                              </h6>
                                              <div className="content">
                                                <p
                                                  className="m-0 "
                                                  style={{
                                                    maxWidth: "max-content",
                                                    fontSize: 12,
                                                  }}
                                                >
                                                  {convertToMomentDate(clientDetails?.createdAt)}
                                                </p>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        {
                                          assignment?.clientCaseloadMapping?.map((item, index) => {
                                            return (
                                              <div
                                                className="bottom px-2 py-2 d-flex align-items-center gap-10"
                                                style={{ borderTop: "1px solid rgb(61, 160, 170)" }}
                                                key={index}
                                              >
                                                <div className="imgWrp flex-shrink-0">
                                                  <img
                                                    src={item?.caseTherapist?.therapist_detail?.profile_picture || p1}
                                                    alt=""
                                                    className="img-fluid rounded-circle object-fit-cover"
                                                    style={{ height: 30, width: 30 }}
                                                  />
                                                </div>
                                                <div className="content">
                                                  <h6 className="m-0 fw-sbold themeBlue">
                                                    {userFullName(item?.caseTherapist)}
                                                  </h6>
                                                </div>
                                                {item?.caseTherapist?.therapist_detail?.type == "veteran" && <Button
                                                  disabled={assignment?.caseServiceStatus?.title?.toLowerCase() == "discharged"}
                                                  className="d-flex align-items-center justify-content-center commonBtn"
                                                  style={{ fontSize: "14px", height: "30px", minWidth: "60px" }}
                                                  onClick={() => {
                                                    setChangeTherapistId(item?.therapist_id)
                                                    setCurrentEntry(assignment);
                                                    setShowChangeModal(true);
                                                  }}
                                                >
                                                  Change
                                                </Button>}
                                              </div>
                                            )
                                          })
                                        }
                                      </div>
                                    </Col>
                                  )
                                })}
                              </Row>
                            )
                              : <NoRecordFound message={'No therapist has been assigned yet.'} />)
                          }
                        </Col>

                      </Row>


                    </Col>
                    <Col lg="12" className="my-3">
                      <div className="d-flex justify-content-between my-3">
                        <div>
                          <h6 className="m-0 fw-bold ">Caseload History</h6>
                        </div>
                        <div>
                          {
                            caseloadPending?.case_status != "pending" &&
                            <Button
                              disabled={newCreateCaseloadLoading || isFetching}
                              onClick={() => { setModalType("newCaseload"); setShowDischargeModal(true) }}
                              style={{ padding: "0px 8px", height: "35px" }}
                              className="d-flex align-items-center justify-content-center commonBtn"
                            >
                              Add Caseload
                            </Button>
                          }
                        </div>
                      </div>
                      {
                        caseLoadsList?.record?.clientCaseloadsDischarged?.length > 0 ?
                          <div>
                            <Accordion className="my-4" >
                              {
                                caseLoadsList?.record?.clientCaseloadsDischarged?.map((item, index) =>
                                  <Accordion.Item eventKey={index.toString()} key={index}>
                                    <Accordion.Header className='staff-client-accordion'>
                                      <div className='d-flex aalign-items-center justify-content-between w-100 align-items-center'>
                                        <div>
                                          <div className='mb-2'>
                                            <span>Discharge Date:</span> {convertToMomentDate(item?.discharge_date)}
                                          </div>
                                        </div>
                                        <div style={{ marginRight: "10px" }}>
                                        </div>
                                      </div>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                      <Col lg="12" className="my-3">
                                        {
                                          item?.clientCaseloadTherapist?.length > 0 && (
                                            <Row>
                                              {item?.clientCaseloadTherapist?.map(assignment => {
                                                if (assignment?.status != 65) return (
                                                  <Col md="6" className="my-2">
                                                    <div className="w-100 d-flex justify-content-between align-items-center mb-2">
                                                      <h6 class="m-0 themeBlue fw-bold">
                                                        {" "}
                                                        <span class="" style={{ color: " rgb(61, 160, 170)" }}>
                                                          ■
                                                        </span>{" "}
                                                        Discipline: {assignment?.caseDiscipline?.assign_term}

                                                      </h6>
                                                    </div>
                                                    <div
                                                      className="cardCstm rounded shadow"
                                                      style={{ border: "1px solid rgb(61, 160, 170)" }}
                                                    >
                                                      <div className="top px-2">
                                                        <div className="d-flex align-items-center justify-content-between">
                                                          <div className="left">
                                                            <h6
                                                              class="m-0 themeBlue fw-bold pb-2"
                                                              style={{ fontSize: 14 }}
                                                            >
                                                              {" "}
                                                              <span
                                                                class=""
                                                                style={{ color: " rgb(61, 160, 170)" }}
                                                              >
                                                                ■
                                                              </span>{" "}
                                                              Service Status
                                                            </h6>
                                                            <div className="content">
                                                              <Dropdown onSelect={(e) => handleServiceStatus(e, assignment?.id)}>
                                                                <Dropdown.Toggle
                                                                  disabled
                                                                  className="border-0 text-dark px-3 py-1 d-flex align-items-center justify-content-between fw-sbold"
                                                                  style={{
                                                                    background: "#F3F3F3",
                                                                    height: "32px",
                                                                    fontSize: "13px",
                                                                    borderRadius: "20px",
                                                                    minWidth: "130px",
                                                                    boxShadow: "inset 0 0 2px #ccc",
                                                                  }}
                                                                  id="dropdown-basic"
                                                                >
                                                                  <span style={{ whiteSpace: "nowrap" }}>{assignment?.caseServiceStatus?.title}</span>
                                                                  <span className="ms-2">
                                                                    <svg
                                                                      xmlns="http://www.w3.org/2000/svg"
                                                                      width="10"
                                                                      height="5"
                                                                      viewBox="0 0 10 5"
                                                                      fill="none"
                                                                    >
                                                                      <path
                                                                        d="M4.99997 4.27048L0.816406 0.0869141H9.18353L4.99997 4.27048Z"
                                                                        fill="#1C1B1F"
                                                                      />
                                                                    </svg>
                                                                  </span>
                                                                </Dropdown.Toggle>

                                                                <Dropdown.Menu className="w-100 small p-0" style={{ fontSize: "13px" }}>
                                                                  {
                                                                    serviceStatusOptions?.map((item, index) => (
                                                                      <Dropdown.Item key={index} eventKey={item.value}>
                                                                        {item.label}
                                                                      </Dropdown.Item>
                                                                    ))
                                                                  }
                                                                </Dropdown.Menu>
                                                              </Dropdown>
                                                            </div>
                                                          </div>
                                                          <div className="right my-2">
                                                            <h6
                                                              class="m-0 themeBlue fw-bold pb-2"
                                                              style={{ fontSize: 14 }}
                                                            >
                                                              {" "}
                                                              <span
                                                                class=""
                                                                style={{ color: " rgb(61, 160, 170)" }}
                                                              >
                                                                ■
                                                              </span>{" "}
                                                              Referred
                                                            </h6>
                                                            <div className="content">
                                                              <p
                                                                className="m-0 "
                                                                style={{
                                                                  maxWidth: "max-content",
                                                                  fontSize: 12,
                                                                }}
                                                              >
                                                                {convertToMomentDate(assignment?.createdAt)}
                                                              </p>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <div className="d-flex align-items-center justify-content-between">
                                                          <div className="left">
                                                            <h6
                                                              class="m-0 themeBlue fw-bold pb-2"
                                                              style={{ fontSize: 14 }}
                                                            >
                                                              {" "}
                                                              <span
                                                                class=""
                                                                style={{ color: " rgb(61, 160, 170)" }}
                                                              >
                                                                ■
                                                              </span>{" "}
                                                              Assessment Date
                                                            </h6>
                                                            <div className="content">
                                                              <p
                                                                className="m-0"
                                                                style={{
                                                                  maxWidth: "max-content",
                                                                  fontSize: 12,
                                                                }}
                                                              >
                                                                --
                                                              </p>
                                                            </div>
                                                          </div>
                                                          <div className="right my-2">
                                                            <h6
                                                              class="m-0 themeBlue fw-bold pb-2"
                                                              style={{ fontSize: 14 }}
                                                            >
                                                              {" "}
                                                              <span
                                                                class=""
                                                                style={{ color: " rgb(61, 160, 170)" }}
                                                              >
                                                                ■
                                                              </span>{" "}
                                                              Start Date
                                                            </h6>
                                                            <div className="content">
                                                              <p
                                                                className="m-0 "
                                                                style={{
                                                                  maxWidth: "max-content",
                                                                  fontSize: 12,
                                                                }}
                                                              >
                                                                --
                                                              </p>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      {
                                                        assignment?.clientCaseloadMapping?.map((item, index) => {
                                                          return (
                                                            <div
                                                              className="bottom px-2 py-2 d-flex align-items-center gap-10"
                                                              style={{ borderTop: "1px solid rgb(61, 160, 170)" }}
                                                              key={index}
                                                            >
                                                              <div className="imgWrp flex-shrink-0">
                                                                <img
                                                                  src={item?.caseTherapist?.therapist_detail?.profile_picture || p1}
                                                                  alt=""
                                                                  className="img-fluid rounded-circle object-fit-cover"
                                                                  style={{ height: 30, width: 30 }}
                                                                />
                                                              </div>
                                                              <div className="content">
                                                                <h6 className="m-0 fw-sbold themeBlue">
                                                                  {userFullName(item?.caseTherapist)}
                                                                </h6>
                                                              </div>
                                                            </div>
                                                          )
                                                        })
                                                      }
                                                    </div>
                                                  </Col>
                                                )
                                              })}
                                            </Row>
                                          )
                                        }
                                      </Col>
                                    </Accordion.Body>
                                  </Accordion.Item>
                                )
                              }
                            </Accordion>
                            <CstmPagination
                              totalPages={totalPages}
                              activePage={currentPage}
                              handlePageChange={handlePageChange}
                            />
                          </div> : <NoRecordFound message={NO_HISTORY_FOUND} />
                      }
                    </Col>
                  </Row>
                </Col> */}
                {/* <Col lg="6" className="">
                  <Row>
                    <TrackAttendance
                      clientCaseloadTherapist={assignedTherapist || []}
                      refetch={refetch}
                    />
                    <Attachments
                      resources={clientDetails?.clientResources || []}
                      uploadDocuments={uploadDocuments}
                    />

                    <Row>
                      <Col lg="12" className="my-2">
                        <div className="d-flex align-items-center justify-content-between flex-wrap gap-10">
                          <h6 className="m-0 themeBlue fw-sbold">Track Attendence</h6>
                          <div className="w-100">
                            <CommonSelect
                              option={clientPrograms?.programs?.length > 0 ? clientPrograms?.programs?.map((item) => ({ label: item?.programMembers?.name, value: item?.program_id })) : []}
                              onChange={(e) => handleProgram(e)}
                              value={programId}
                              isLoading={clientProgramsLoading}
                            />
                          </div>
                        </div>
                      </Col>

                      <Col lg="12" className="my-2">
                        <div className={`${styles.tableResponsive} tableResponsive table-responsive border rounded-2 mb-3 pb-0`}>
                          <table className={`${styles.table} table mb-0`}>
                            <thead>
                              <tr>
                                <th className="text-dark fw-bold bg-transparent">Event Date</th>
                                <th className="text-dark fw-bold bg-transparent">PRESENT</th>
                              </tr>
                            </thead>
                            <tbody>
                              {!programId?.value ? <tr><td colSpan={2} className="border-0 p-2 text-center">Please Select a Program</td></tr> : attendaceList?.lessonDates?.length ? attendaceList?.lessonDates?.map((item, index) => (
                                <tr key={`${index}-${index}`}>
                                  <td className="border-0 p-2 text-capitalize">
                                    {convertToMomentDate(item?.session_date) || "--"}
                                  </td>
                                  <td className="border-0 p-2">
                                    <span>
                                      {item?.attendance?.[0]?.attendance === "present" ? <PresentIcon /> : <AbsentIcon />}
                                    </span>
                                  </td>
                                </tr>
                              )) : <tr><td colSpan={2} className="border-0 p-2 text-center">No Record Found</td></tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      </Col>
                    </Row>
                  </Row>
                </Col> */}
              </Row>
          }
        </Container>
      </section>
    </>
  );
};

export default ClientChatterDetail;

const PresentIcon = () => {
  return (<svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20Z"
      fill="#16BF12"
    />
  </svg>)
}

const AbsentIcon = () => {
  return (
    <svg
      width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_5342_36802" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5342_36802)">
        <path d="M12 21C10.7468 21 9.58226 20.763 8.49619 20.2943C7.39072 19.8173 6.43908 19.1749 5.63211 18.3679C4.82514 17.5609 4.18269 16.6093 3.70567 15.5038C3.23702 14.4177 3 13.2532 3 12C3 10.7468 3.23702 9.58226 3.70567 8.49619C4.18269 7.39072 4.82514 6.43908 5.63211 5.63211C6.43908 4.82514 7.39072 4.18269 8.49619 3.70567C9.58226 3.23702 10.7468 3 12 3C13.2532 3 14.4177 3.23702 15.5038 3.70567C16.6093 4.18269 17.5609 4.82514 18.3679 5.63211C19.1749 6.43908 19.8173 7.39072 20.2943 8.49619C20.763 9.58226 21 10.7468 21 12C21 13.2532 20.763 14.4177 20.2943 15.5038C19.8173 16.6093 19.1749 17.5609 18.3679 18.3679C17.5609 19.1749 16.6093 19.8173 15.5038 20.2943C14.4177 20.763 13.2532 21 12 21Z" fill="#ECECEC" stroke="#16BF12" stroke-width="2" />
      </g>
    </svg>
  )
}